// @flow

import React from 'react';
import PropTypes from 'prop-types';
import ProjectContentDescription from '../ContentDescription';
import Tooltip from '../../../../../Resources/Common/Tooltip';

export default function CommercialStrat(props) {
  const { proposalUid, blocked, hasRights } = props;
  return (
    <ProjectContentDescription
      title="Stratégie d'acquisition"
      tooltip={Tooltip.ProjectOfferCommercialStrat.description}
      proposalUid={proposalUid}
      hasRights={hasRights}
      blocked={blocked}
    />
  );
}

CommercialStrat.propTypes = {
  hasRights: PropTypes.bool.isRequired,
  blocked: PropTypes.bool.isRequired,
  proposalUid: PropTypes.string
};

CommercialStrat.defaultProps = {
  proposalUid: undefined
};
